import Backend from 'backend';
import {inject} from 'aurelia-framework';

@inject(Backend)
export class PackagingIndexScreen {
    backend;
    packagings = [];

    constructor(backend) {
        this.backend = backend;
    }

    activate() {
        return this.refresh();
    }

    refresh() {
        return this.backend.PackagingCrud_index()
            .then(result => this.packagings = result);
    }
}